import { type HTMLAttributes, memo } from 'react';

import { cn } from '@/shared/utils/cn';

export interface ProfileDetailsVibeRootProps extends HTMLAttributes<HTMLDivElement> {}

export const ProfileDetailsVibeRoot = memo(function ProfileDetailsVibeRoot({
  className,
  children,
  ...props
}: ProfileDetailsVibeRootProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)} {...props}>
      {children}
    </div>
  );
});
